import { FolderOpenOutlined, MenuOutlined } from '@ant-design/icons';
import { InspectorWrapper } from '@smx-ui-inspector/inspector-wrapper';
import { Button, Divider, Drawer, Flex, Grid, Layout, Menu, theme } from 'antd';
import { useState } from 'react';
import { Outlet, generatePath, useNavigate, useParams } from 'react-router-dom';

import { API, paths } from '../common';
import { Logo } from '../components/logo';

const { Header, Sider, Content } = Layout;

const TopLayout = () => {
    const navigate = useNavigate();
    const { user_sub } = useParams<{ user_sub: string }>();
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;
    const [isNavOpen, setIsNavOpen] = useState(false);

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    const getDefaultKeyForMenu = () => {
        const currentUrl = window.location.href;
        if (currentUrl.includes('sharing-document')) {
            return 1;
        }
        return 1;
    };

    const documentListPath = user_sub ? generatePath(paths.DOCUMENT_LIST, { user_sub }) : paths.MAIN;

    const menuItems = [
        {
            key: '1',
            icon: <FolderOpenOutlined />,
            label: 'Documents',
            onClick: () => {
                navigate(documentListPath);
                setIsNavOpen(false);
            },
        },
    ];

    const menuStyle = { height: isMobile ? 'auto' : '100%' };

    const menuContent = (
        <>
            <Flex justify="center" style={{ borderInlineEnd: '1px solid rgba(5, 5, 5, 0.06)' }}>
                <Logo type={'short'} margin={'10px'} />
            </Flex>
            <Divider style={{ margin: '1px 10px', minWidth: 'calc(100% - 20px)', width: 'calc(100% - 20px)' }} />
            <Menu
                style={menuStyle}
                theme="light"
                mode="inline"
                defaultSelectedKeys={[getDefaultKeyForMenu().toString()]}
                items={menuItems}
            />
        </>
    );

    return (
        <Flex flex={1} style={{ height: '100%' }}>
            {!isMobile && (
                <Sider width={160} style={{ background: colorBgContainer }}>
                    {menuContent}
                </Sider>
            )}
            {isMobile && (
                <Drawer
                    placement="left"
                    open={isNavOpen}
                    onClose={() => setIsNavOpen(false)}
                    width={200}
                    bodyStyle={{ padding: 0, overflow: 'hidden' }}
                    closable={false}
                >
                    {menuContent}
                </Drawer>
            )}
            <Layout style={{ width: '10%' }}>
                <Header
                    style={{
                        padding: '0 20px',
                        background: colorBgContainer,
                        alignItems: 'center',
                        borderInlineStart: '1px solid rgba(5, 5, 5, 0.06)',
                    }}
                >
                    <Flex justify={'space-between'} align="center">
                        <Flex justify="start" align="center" style={{ gap: 8 }}>
                            {isMobile && (
                                <Button
                                    type="text"
                                    icon={<MenuOutlined />}
                                    onClick={() => setIsNavOpen((prev) => !prev)}
                                    aria-label="Open navigation"
                                />
                            )}
                            <label style={{ fontWeight: 'bold', fontSize: 20 }}>Sitemax - Contractor</label>
                        </Flex>
                    </Flex>
                </Header>
                <Divider style={{ margin: '0px 10px', minWidth: 'calc(100% - 20px)', width: 'calc(100% - 20px)' }} />
                <Content
                    style={{
                        padding: 24,
                        background: 'white',
                        overflow: 'scroll',
                    }}
                >
                    <Outlet />
                    <InspectorWrapper filterProject={API.PROJECT_FILTER?.split(',')} />
                </Content>
            </Layout>
        </Flex>
    );
};

export default TopLayout;
